<template lang="pug">
.PrivacyContest(v-if="$route.path !== ROUTES.PRIVACY")
  .d-flex.--col.__cont
    p
     | {{ L['privacy.contest.use_cookie'] }}&nbsp;
     p.u-nowrap {{ L['privacy.contest.learn_more'] }}&nbsp;
      | <router-link :to="ROUTES.PRIVACY" target="_blank"> {{ L['privacy.contest.policy'] }}</router-link>.

    .d-flex.__ctrls.--wrap
      .Btn.--act.__sets(name="oepn-cks-modal", @click="$emit('openSets')") {{ L['privacy.contest.settings'] }}
      .Btn.--act.__accept(name="accept-cks" @click="$emit('save')") {{ L['privacy.contest.accept'] }}
</template>
<script>
import content from 'content';

export default {
  name: 'PrivacyContest',
  inject: ['mq'],
  emits: ['save', 'openSets'],
  static: () => ({ L: content }),
};

</script>
<style scoped>
.PrivacyContest {
  --c: #203254;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: var(--zi-privacy-contest);

  padding: 60px var(--page-pad) 150px;

  color: var(--white);

  background: var(--c);
  box-shadow: 0 0 30px 0 var(--black-20);

  --k-slide-from-y: 300px;
  --k-slide-to-y: 0;
  animation: k-slide .5s 2s both;
}

p { line-height: 1.5em; }

a,
a:visited {
  color: inherit;

  border-bottom: 1px solid var(--black);
}

.__cont {
  --gap: 28px;
  max-width: var(--page-mw);
}

.__ctrls {
  --gap: 24px;

  .Btn.--act {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 148px;
    height: 40px;

    color: var(--white);

    background-color: var(--c);
    border: 1px solid var(--white);
    border-radius: 0;
    box-shadow: none !important;

    &:hover {
      background-color: var(--c);
      border: 1px solid var(--white);
    }

    &.__accept {
      color: var(--c);

      background-color: var(--white);
    }
  }
}

@media (min-width: 740px) {
}

@media (max-width: 739px) {
  .PrivacyContest {
    padding-bottom: 60px;
  }
}
</style>
